module.exports = __webpack_public_path__ + "img/icon-navigation-upward-arrow-green.4cd976c3.svg";